(function () {
    "use strict";

    function showToast(message, type) {
        const template = document.getElementById("ns-atc-toast-template");
        if (!template) return;

        const clone = template.querySelector(".toast").cloneNode(true);
        const id = "ns-toast-" + Date.now();
        clone.setAttribute("id", id);
        clone.classList.add('toast--' + type);

        if (type === 'danger' || type === 'error') {
            clone.classList.add('bg-danger', 'text-white');
        } else if (type === 'success') {
            clone.classList.add('bg-success', 'text-white');
        } else if (type === 'warning') {
            clone.classList.add('bg-warning', 'text-dark');
        }

        const messageEl = clone.querySelector(".ns-toast-message");
        if (messageEl) {
            try {
                messageEl.textContent = decodeURIComponent(message);
            } catch (e) {
                messageEl.textContent = message;
            }
        }

        const container = document.getElementById("ns-atc-toast-container");
        if (container) {
            container.appendChild(clone);
        }

        const el = document.getElementById(id);
        if (el) {
            if (typeof bootstrap !== "undefined" && bootstrap.Toast) {
                const t = new bootstrap.Toast(el);
                t.show();
                el.addEventListener("hidden.bs.toast", function () {
                    el.remove();
                });
            }
        }
    }


    document.addEventListener("input", function (e) {
        const targetInput = e.target.closest(".negarshop-smart-login input[name='username'], .negarshop-smart-login input#coderboy-captcha");
        if (targetInput) {
            const smartLogin = targetInput.closest(".negarshop-smart-login");
            const usernameInput = smartLogin.querySelector("input[name='username']");
            const captchaInput = smartLogin.querySelector("input#coderboy-captcha");
            const stepOneSubmit = smartLogin.querySelector(".login-steps[data-step='1'] .form-submit");

            if (stepOneSubmit) {
                const isUsernameValid = usernameInput && usernameInput.value.trim().length > 0;
                const isCaptchaValid = !captchaInput || captchaInput.value.trim().length > 0;

                if (isUsernameValid && isCaptchaValid) {
                    stepOneSubmit.classList.remove("disabled");
                } else {
                    stepOneSubmit.classList.add("disabled");
                }
            }
        }
    });

    document.addEventListener("change-captcha", function (e) {
        const captchaImg = e.target;
        if (captchaImg) {
            captchaImg.classList.add('loading');
            const originalSrc = captchaImg.getAttribute("src").split('?')[0];
            captchaImg.setAttribute("src", originalSrc + '?' + Math.floor(Math.random() * 100000));
            captchaImg.onload = function () {
                captchaImg.classList.remove('loading');
            };
        }
    });

    document.addEventListener("keydown", function (e) {
        // Prevent form submission on enter in mobile number input and trigger code sending
        const mobileInput = e.target.closest(".negarshop-mobile-verify-form input#ns-mobile");
        if (mobileInput && e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
            const wrapper = mobileInput.closest(".negarshop-mobile-verify-form");
            const sendBtn = wrapper ? wrapper.querySelector(".send-code") : null;
            if (sendBtn) {
                sendBtn.click();
            }
            return;
        }

        // Prevent form submission on enter in verification code input and trigger code verification
        const verifyInput = e.target.closest(".negarshop-mobile-verify-form input#ns-mobile-verify");
        if (verifyInput && e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
            const wrapper = verifyInput.closest(".negarshop-mobile-verify-form") || document.querySelector(".negarshop-mobile-verify-form.step-2");
            const verifyBtn = wrapper ? wrapper.querySelector(".verify-code") : null;
            if (verifyBtn) {
                verifyBtn.click();
            }
            return;
        }
    });

    document.addEventListener("click", function (e) {
        // Mobile Verify - Send Code
        const sendCodeBtn = e.target.closest(".negarshop-mobile-verify-form .send-code");
        if (sendCodeBtn) {
            e.preventDefault();
            e.stopPropagation();
            const form = sendCodeBtn.closest(".negarshop-mobile-verify-form");
            if (form) form.dispatchEvent(new CustomEvent("send_code", {bubbles: true}));
            return;
        }

        // Mobile Verify - Verify Code
        const verifyCodeBtn = e.target.closest(".negarshop-mobile-verify-form.step-2 .verify-code");
        if (verifyCodeBtn) {
            e.preventDefault();
            e.stopPropagation();
            const form = verifyCodeBtn.closest(".negarshop-mobile-verify-form");
            if (form) form.dispatchEvent(new CustomEvent("verify_code", {bubbles: true}));
            return;
        }

        const loginWrapper = e.target.closest(".negarshop-smart-login");
        if (!loginWrapper) return;
        const stepOneWrapper = loginWrapper.querySelector(".login-steps[data-step='1']");
        const stepTwoWrapper = loginWrapper.querySelector(".login-steps[data-step='2']");

        if (!stepOneWrapper || !stepTwoWrapper) return;

        // Change Captcha
        const captchaImg = e.target.closest(".negarshop-smart-login .captcha-wrapper img");
        if (captchaImg) {
            captchaImg.dispatchEvent(new CustomEvent('change-captcha', {bubbles: true}));
            return;
        }


        const nextStep = e.target.closest(".login-steps[data-step='1'] .form-submit");
        if (nextStep) {
            const stepOne = nextStep.closest(".login-steps[data-step='1']");
            if (stepOne && stepOne.style.display === 'none') return;

            e.preventDefault();
            const usernameInput = loginWrapper.querySelector("input[name='username']");
            if (usernameInput && usernameInput.value) {
                loginWrapper.dispatchEvent(new CustomEvent("smart_login_detect_type", {
                    bubbles: true,
                    detail: { username: usernameInput.value }
                }));
            }
            return;
        }

        const submitStepTwo = e.target.closest(".login-steps[data-step='2'] .form-submit");
        if (submitStepTwo) {
            const stepTwo = submitStepTwo.closest(".login-steps[data-step='2']");
            if (stepTwo && stepTwo.style.display === 'none') return;

            e.preventDefault();
            const form = loginWrapper.querySelector("form");
            if (form) {
                form.dispatchEvent(new CustomEvent("smart_login_submit", {bubbles: true}));
            }
            return;
        }

        // Switch to Password login method
        const switchToPasswordBtn = e.target.closest(".negarshop-smart-login .switch-to-password");
        if (switchToPasswordBtn) {
            e.preventDefault();
            const passwordWrapper = loginWrapper.querySelector(".password-wrapper");
            const otpCodeWrapper = loginWrapper.querySelector(".otp-code-wrapper");
            const passwordInput = loginWrapper.querySelector("input#ns-password");
            const switchToOtpBtn = loginWrapper.querySelector(".switch-to-otp");

            if (otpCodeWrapper) otpCodeWrapper.style.display = 'none';
            if (passwordWrapper) passwordWrapper.style.display = 'block';
            if (passwordInput) passwordInput.focus();

            if (switchToPasswordBtn) switchToPasswordBtn.classList.add("hide");
            const haveNumber = loginWrapper.getAttribute("data-have-number") === "true";
            if (switchToOtpBtn) {
                if (haveNumber) {
                    switchToOtpBtn.classList.remove("hide");
                } else {
                    switchToOtpBtn.classList.add("hide");
                }
            }
            return;
        }

        // Switch to OTP login method
        const switchToOtpBtn = e.target.closest(".negarshop-smart-login .switch-to-otp");
        if (switchToOtpBtn) {
            e.preventDefault();
            const passwordWrapper = loginWrapper.querySelector(".password-wrapper");
            const otpCodeWrapper = loginWrapper.querySelector(".otp-code-wrapper");
            const codeInput = loginWrapper.querySelector("input#auth-code");
            const switchToPasswordBtn = loginWrapper.querySelector(".switch-to-password");

            if (passwordWrapper) passwordWrapper.style.display = 'none';
            if (otpCodeWrapper) otpCodeWrapper.style.display = 'block';
            if (codeInput) codeInput.focus();

            if (switchToOtpBtn) switchToOtpBtn.classList.add("hide");
            const havePassword = loginWrapper.getAttribute("data-have-password") === "true";
            if (switchToPasswordBtn) {
                if (havePassword) {
                    switchToPasswordBtn.classList.remove("hide");
                } else {
                    switchToPasswordBtn.classList.add("hide");
                }
            }

            const otpSent = loginWrapper.getAttribute("data-otp-sent") === "true";
            if (!otpSent) {
                loginWrapper.dispatchEvent(new CustomEvent("smart_login_step1", {bubbles: true}));
            }
            return;
        }

        // Resend code
        const resendBtn = e.target.closest(".negarshop-smart-login .resend-code");
        if (resendBtn) {
            const smartLogin = resendBtn.closest(".negarshop-smart-login");
            if (smartLogin) smartLogin.dispatchEvent(new CustomEvent("smart_login_step1", {bubbles: true}));
            return;
        }

        // Back button
        const backBtn = e.target.closest(".negarshop-smart-login .back-btn");
        if (backBtn) {
            const smartLogin = backBtn.closest(".negarshop-smart-login");
            if (smartLogin) {
                smartLogin.removeAttribute("data-otp-sent");
                smartLogin.dispatchEvent(new CustomEvent("smart_login_change_step", {
                    bubbles: true,
                    detail: {step: 1}
                }));
                const inputs = smartLogin.querySelectorAll('#ns-mobile, #ns-password, #auth-code');
                inputs.forEach(input => {
                    input.value = "";
                    input.removeAttribute("readonly");
                });
                const debugWrapper = smartLogin.querySelector('.debug-code-wrapper');
                const debugVal = smartLogin.querySelector('.debug-code-value');
                if (debugWrapper) debugWrapper.style.display = 'none';
                if (debugVal) debugVal.textContent = '';
            }
            return;
        }

    });

    let smsTimerInterval = null;
    function startSmsTimer(duration, timerEl, resendBtn) {
        if (smsTimerInterval) clearInterval(smsTimerInterval);
        if (resendBtn) resendBtn.classList.add("hide");

        let timer = duration, minutes, seconds;
        smsTimerInterval = setInterval(function () {
            minutes = parseInt(timer / 60, 10);
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            if (timerEl) timerEl.textContent = minutes + ":" + seconds;

            if (--timer < 0) {
                clearInterval(smsTimerInterval);
                if (resendBtn) resendBtn.classList.remove("hide");
            }
        }, 1000);
    }

    document.addEventListener("smart_login_detect_type", function (e) {
        const smartLogin = e.target;
        const username = e.detail.username;
        const stepOneWrapper = smartLogin.querySelector(".login-steps[data-step='1']");
        const stepTwoWrapper = smartLogin.querySelector(".login-steps[data-step='2']");
        const loader = stepTwoWrapper ? stepTwoWrapper.querySelector(".login-steps-loader") : null;
        const passwordWrapper = stepTwoWrapper ? stepTwoWrapper.querySelector(".password-wrapper") : null;
        const otpCodeWrapper = stepTwoWrapper ? stepTwoWrapper.querySelector(".otp-code-wrapper") : null;
        const submitBtn = stepTwoWrapper ? stepTwoWrapper.querySelector(".form-submit") : null;
        const submitBtnRow = submitBtn ? submitBtn.closest(".field-row") : null;
        const changeModeWrapper = stepTwoWrapper ? stepTwoWrapper.querySelector(".change-login-mode") : null;
        const resultEl = smartLogin.querySelector(".login-result");

        if (resultEl) {
            resultEl.textContent = "";
            resultEl.className = "login-result";
        }

        if (stepOneWrapper) stepOneWrapper.style.display = 'none';
        if (stepTwoWrapper) stepTwoWrapper.style.display = 'block';
        if (loader) loader.style.display = 'block';
        if (passwordWrapper) passwordWrapper.style.display = 'none';
        if (otpCodeWrapper) otpCodeWrapper.style.display = 'none';
        if (submitBtn) submitBtn.classList.add("disabled");
        if (submitBtnRow) submitBtnRow.style.display = 'none';
        if (changeModeWrapper) changeModeWrapper.style.display = 'none';

        const nonceEl = smartLogin.querySelector("[name='_wpnonce']");
        const nonceVal = nonceEl ? nonceEl.value : '';

        const params = new URLSearchParams();
        params.append('action', 'negarshop_smart_login_get_login_type');
        params.append('username', username);
        params.append('_nonce', nonceVal);

        fetch(NS_OBJ.ajax_url, {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: params
        })
            .then(res => res.json())
            .then(response => {
                if (!response.success) {
                    if (loader) loader.style.display = 'none';
                    const errMsg = response.data || (NS_OBJ.i18n.an_error || 'خطایی رخ داده است.');
                    showToast(errMsg, 'danger');
                    if (stepOneWrapper) stepOneWrapper.style.display = 'block';
                    if (stepTwoWrapper) stepTwoWrapper.style.display = 'none';
                    return;
                }

                const data = response.data;
                smartLogin.setAttribute("data-have-password", data.have_password ? "true" : "false");
                smartLogin.setAttribute("data-have-number", (data.type === 'otp' || data.have_number) ? "true" : "false");

                const switchToPasswordLink = smartLogin.querySelector(".switch-to-password");
                const switchToOtpLink = smartLogin.querySelector(".switch-to-otp");

                if (data.type === 'otp') {
                    if (otpCodeWrapper) otpCodeWrapper.style.display = 'block';
                    if (submitBtn) submitBtn.classList.remove("disabled");

                    const codeInput = otpCodeWrapper.querySelector("input#auth-code");
                    if (codeInput) codeInput.focus();

                    // Manage switch buttons visibility
                    if (switchToOtpLink) switchToOtpLink.classList.add("hide");
                    if (data.have_password) {
                        if (switchToPasswordLink) switchToPasswordLink.classList.remove("hide");
                    } else {
                        if (switchToPasswordLink) switchToPasswordLink.classList.add("hide");
                    }

                    smartLogin.dispatchEvent(new CustomEvent("smart_login_step1", {bubbles: true}));
                } else if (data.type === 'password') {
                    if (loader) loader.style.display = 'none';
                    if (passwordWrapper) passwordWrapper.style.display = 'block';
                    if (submitBtn) submitBtn.classList.remove("disabled");
                    if (submitBtnRow) submitBtnRow.style.display = '';
                    if (changeModeWrapper) changeModeWrapper.style.display = '';

                    const passwordInput = passwordWrapper.querySelector("input#ns-password");
                    if (passwordInput) passwordInput.focus();

                    // Manage switch buttons visibility
                    if (switchToPasswordLink) switchToPasswordLink.classList.add("hide");
                    if (data.have_number) {
                        if (switchToOtpLink) switchToOtpLink.classList.remove("hide");
                    } else {
                        if (switchToOtpLink) switchToOtpLink.classList.add("hide");
                    }
                } else {
                    if (loader) loader.style.display = 'none';
                    const errMsg = data.message || (NS_OBJ.i18n.an_error || 'خطایی رخ داده است.');
                    showToast(errMsg, 'danger');
                    if (stepOneWrapper) stepOneWrapper.style.display = 'block';
                    if (stepTwoWrapper) stepTwoWrapper.style.display = 'none';
                }
            })
            .catch(err => {
                console.error(err);
                if (loader) loader.style.display = 'none';
                const errMsg = NS_OBJ.i18n.an_error || 'خطا در ارتباط با سرور.';
                showToast(errMsg, 'danger');
                if (stepOneWrapper) stepOneWrapper.style.display = 'block';
                if (stepTwoWrapper) stepTwoWrapper.style.display = 'none';
            });
    });

    document.addEventListener("smart_login_step1", function (e) {
        const smartLogin = e.target;
        if (smartLogin.classList.contains("loading")) return;

        const usernameInput = smartLogin.querySelector("input[name='username']");
        const nonceEl = smartLogin.querySelector("[name='_wpnonce']");
        const resultEl = smartLogin.querySelector(".login-result");

        if (resultEl) {
            resultEl.textContent = "";
            resultEl.className = "login-result";
        }

        const username = usernameInput ? usernameInput.value : '';
        const nonceVal = nonceEl ? nonceEl.value : '';

        const params = new URLSearchParams();
        params.append('action', 'negarshop_smart_login');
        params.append('mobile', username);
        params.append('_nonce', nonceVal);

        smartLogin.classList.add("loading");

        fetch(NS_OBJ.ajax_url, {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: params
        })
            .then(res => res.json())
            .then(response => {
                smartLogin.classList.remove("loading");
                const stepTwoWrapper = smartLogin.querySelector(".login-steps[data-step='2']");
                const loader = stepTwoWrapper ? stepTwoWrapper.querySelector(".login-steps-loader") : null;
                if (loader) loader.style.display = 'none';

                const submitBtn = stepTwoWrapper ? stepTwoWrapper.querySelector(".form-submit") : null;
                const submitBtnRow = submitBtn ? submitBtn.closest(".field-row") : null;
                const changeModeWrapper = stepTwoWrapper ? stepTwoWrapper.querySelector(".change-login-mode") : null;
                if (submitBtnRow) submitBtnRow.style.display = '';
                if (changeModeWrapper) changeModeWrapper.style.display = '';

                if (response.success) {
                    smartLogin.setAttribute("data-otp-sent", "true");
                    const data = response.data;
                    const timerEl = smartLogin.querySelector(".sms-timer");
                    const resendBtn = smartLogin.querySelector(".resend-code");
                    const debugWrapper = smartLogin.querySelector(".debug-code-wrapper");
                    const debugVal = smartLogin.querySelector(".debug-code-value");

                    if (timerEl && data.login && data.login.timer) {
                        startSmsTimer(data.login.timer, timerEl, resendBtn);
                    }

                    if (data.login && data.login.debug_code) {
                        if (debugVal) debugVal.textContent = data.login.debug_code;
                        if (debugWrapper) debugWrapper.style.display = 'block';
                    } else {
                        if (debugWrapper) debugWrapper.style.display = 'none';
                    }
                } else {
                    const errMsg = response.data.message || response.data || (NS_OBJ.i18n.an_error || 'خطایی رخ داده است.');
                    showToast(errMsg, 'danger');
                }
            })
            .catch(err => {
                console.error(err);
                smartLogin.classList.remove("loading");
                const stepTwoWrapper = smartLogin.querySelector(".login-steps[data-step='2']");
                const loader = stepTwoWrapper ? stepTwoWrapper.querySelector(".login-steps-loader") : null;
                if (loader) loader.style.display = 'none';

                const submitBtn = stepTwoWrapper ? stepTwoWrapper.querySelector(".form-submit") : null;
                const submitBtnRow = submitBtn ? submitBtn.closest(".field-row") : null;
                const changeModeWrapper = stepTwoWrapper ? stepTwoWrapper.querySelector(".change-login-mode") : null;
                if (submitBtnRow) submitBtnRow.style.display = '';
                if (changeModeWrapper) changeModeWrapper.style.display = '';

                const errMsg = NS_OBJ.i18n.an_error || 'خطا در ارسال کد تایید.';
                showToast(errMsg, 'danger');
            });
    });

    document.addEventListener("smart_login_change_step", function (e) {
        const smartLogin = e.target;
        const step = e.detail.step;
        const stepOneWrapper = smartLogin.querySelector(".login-steps[data-step='1']");
        const stepTwoWrapper = smartLogin.querySelector(".login-steps[data-step='2']");
        const resultEl = smartLogin.querySelector(".login-result");

        if (resultEl) {
            resultEl.textContent = "";
            resultEl.className = "login-result";
        }

        if (step === 1) {
            if (stepOneWrapper) stepOneWrapper.style.display = 'block';
            if (stepTwoWrapper) stepTwoWrapper.style.display = 'none';
            if (smsTimerInterval) clearInterval(smsTimerInterval);
        } else if (step === 2) {
            if (stepOneWrapper) stepOneWrapper.style.display = 'none';
            if (stepTwoWrapper) stepTwoWrapper.style.display = 'block';

            const passwordWrapper = smartLogin.querySelector(".password-wrapper");
            const otpCodeWrapper = smartLogin.querySelector(".otp-code-wrapper");

            if (passwordWrapper && passwordWrapper.style.display !== 'none') {
                const passwordInput = passwordWrapper.querySelector("input#ns-password");
                if (passwordInput) passwordInput.focus();
            } else if (otpCodeWrapper && otpCodeWrapper.style.display !== 'none') {
                const codeInput = otpCodeWrapper.querySelector("input#auth-code");
                if (codeInput) codeInput.focus();
            }
        }
    });

    document.addEventListener("smart_login_submit", function (e) {
        const form = e.target;
        const smartLogin = form.closest(".negarshop-smart-login");
        if (!smartLogin || smartLogin.classList.contains("loading")) return;

        const usernameInput = smartLogin.querySelector("input[name='username']");
        const passwordInput = smartLogin.querySelector("input#ns-password");
        const codeInput = smartLogin.querySelector("input#auth-code");
        const nonceEl = smartLogin.querySelector("[name='_wpnonce']");
        const captchaInput = smartLogin.querySelector("input#coderboy-captcha");
        const resultEl = smartLogin.querySelector(".login-result");

        if (resultEl) {
            resultEl.textContent = "";
            resultEl.className = "login-result";
        }

        const username = usernameInput ? usernameInput.value : '';
        const nonceVal = nonceEl ? nonceEl.value : '';
        const captchaVal = captchaInput ? captchaInput.value : '';

        const passwordWrapper = smartLogin.querySelector(".password-wrapper");
        const otpCodeWrapper = smartLogin.querySelector(".otp-code-wrapper");

        const params = new URLSearchParams();
        params.append('_nonce', nonceVal);
        params.append('redirect', smartLogin.querySelector("[name='redirect']") ? smartLogin.querySelector("[name='redirect']").value : '');

        let action = '';
        if (passwordWrapper && passwordWrapper.style.display !== 'none') {
            action = 'negarshop_smart_login_email_pass';
            params.append('email', username);
            params.append('password', passwordInput ? passwordInput.value : '');
        } else if (otpCodeWrapper && otpCodeWrapper.style.display !== 'none') {
            action = 'negarshop_smart_login_auth';
            params.append('mobile', username);
            params.append('code', codeInput ? codeInput.value : '');
        } else {
            return;
        }

        if (captchaInput) {
            params.append('captcha', captchaVal);
        }

        params.append('action', action);
        smartLogin.classList.add("loading");

        fetch(NS_OBJ.ajax_url, {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: params
        })
            .then(res => res.json())
            .then(response => {
                smartLogin.classList.remove("loading");
                if (response.success) {
                    if (resultEl) {
                        resultEl.textContent = response.data.message || (NS_OBJ.i18n.login_redirecting || 'وارد شدید! در حال انتقال...');
                        resultEl.className = 'login-result login-result--success';
                    }
                    setTimeout(() => {
                        window.location.replace(response.data.redirect || window.location.href);
                    }, 1000);
                } else {
                    const errMsg = response.data.message || response.data || (NS_OBJ.i18n.an_error || 'خطایی رخ داده است.');
                    showToast(errMsg, 'danger');
                    if (response.data && response.data.code === 'captcha') {
                        const captchaImg = smartLogin.querySelector(".captcha-wrapper img");
                        if (captchaImg) {
                            captchaImg.classList.add('loading');
                            const originalSrc = captchaImg.getAttribute("src").split('?')[0];
                            captchaImg.setAttribute("src", originalSrc + '?' + Math.floor(Math.random() * 100000));
                            captchaImg.onload = function () {
                                captchaImg.classList.remove('loading');
                            };
                        }
                        const captchaInput = smartLogin.querySelector("input#coderboy-captcha");
                        if (captchaInput) {
                            captchaInput.value = '';
                        }
                        const stepOneSubmit = smartLogin.querySelector(".login-steps[data-step='1'] .form-submit");
                        if (stepOneSubmit) {
                            stepOneSubmit.classList.add("disabled");
                        }
                        smartLogin.dispatchEvent(new CustomEvent("smart_login_change_step", {
                            bubbles: true,
                            detail: {step: 1}
                        }));
                    }
                }
            })
            .catch(err => {
                console.error(err);
                smartLogin.classList.remove("loading");
                const errMsg = NS_OBJ.i18n.an_error || 'خطا در برقراری ارتباط با سرور.';
                showToast(errMsg, 'danger');
            });
    });

    document.addEventListener("submit", function (e) {
        const form = e.target.closest(".negarshop-smart-login form");
        if (form) {
            e.preventDefault();
            const stepTwoWrapper = form.querySelector(".login-steps[data-step='2']");
            if (stepTwoWrapper && stepTwoWrapper.style.display !== 'none') {
                form.dispatchEvent(new CustomEvent("smart_login_submit", {bubbles: true}));
            } else {
                const nextStep = form.querySelector(".login-steps[data-step='1'] .form-submit");
                if (nextStep && !nextStep.classList.contains("disabled")) {
                    nextStep.click();
                }
            }
        }
    });


    document.addEventListener('user_login', function (e) {
        const loginBox = e.target;
        const data = e.detail;
        data.form_data.action = 'negarshop_ajax_login';

        const resultEl = loginBox.querySelector('.login-result');

        if (loginBox.classList.contains('loading')) {
            return;
        }

        loginBox.classList.add('loading');

        const params = new URLSearchParams();
        Object.keys(data.form_data).forEach(key => {
            params.append(key, data.form_data[key]);
        });

        fetch(NS_OBJ.ajax_url, {
            method: "POST",
            body: params
        })
            .then(async response => {
                if (response.redirected && response.url) {
                    window.location.replace(response.url);
                    return;
                }

                const res = await response.json();
                if (res.success) {
                    if (resultEl) {
                        resultEl.classList.remove('login-result--error');
                        resultEl.classList.add('login-result--success');
                        resultEl.innerHTML = NS_OBJ.i18n.login_redirecting;
                    }
                    setTimeout(() => {
                        window.location.replace(data.form_data.redirect);
                    }, 1000);
                } else {
                    loginBox.classList.remove('loading');
                    showToast(res.data || 'خطایی رخ داده است.', 'danger');
                }
            })
            .catch(err => {
                console.error(err);
                loginBox.classList.remove('loading');
                showToast('خطا در برقراری ارتباط با سرور.', 'danger');
            });
    });

    // Mobile verification logic
    document.addEventListener("send_code", function (e) {
        const form = e.target;
        if (form.classList.contains("loading")) {
            return;
        }
        form.classList.add('loading');
        const resultEl = form.querySelector('.login-result');
        if (resultEl) {
            resultEl.textContent = '';
            resultEl.classList.add("hide");
        }

        const mobileInput = form.querySelector("input#ns-mobile");
        if (mobileInput) mobileInput.setAttribute("readonly", "true");

        const nonceEl = form.querySelector("[name='ns-nonce']");

        const params = new URLSearchParams();
        params.append('action', 'negarshop_smart_login_myaccount_verify_mobile');
        params.append('mobile', mobileInput ? mobileInput.value : '');
        params.append('_nonce', nonceEl ? nonceEl.value : '');

        fetch(NS_OBJ.ajax_url, {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: params
        })
            .then(res => res.json())
            .then(response => {
                form.classList.remove('loading');
                if (mobileInput) mobileInput.removeAttribute("readonly");

                if (!response.success) {
                    if (resultEl) {
                        resultEl.textContent = response.data.message || response.data || 'خطایی رخ داده است.';
                        resultEl.className = 'login-result login-result--error';
                        resultEl.classList.remove("hide");
                    }
                    return;
                }

                const step2Form = document.querySelector(".negarshop-mobile-verify-form.step-2");
                if (!step2Form || !step2Form.classList.contains("modal")) {
                    form.style.display = 'none';
                }
                if (step2Form) {
                    if (step2Form.classList.contains("modal")) {
                        if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                            const modal = new bootstrap.Modal(step2Form);
                            modal.show();
                        } else {
                            step2Form.style.display = 'block';
                            step2Form.classList.add('show');
                        }
                    } else {
                        step2Form.style.display = 'block';
                    }
                    const userMobile = step2Form.querySelector(".user-mobile");
                    if (userMobile) userMobile.textContent = response.data.data.mobile;
                    const nsMobileNum = step2Form.querySelector("input#ns-mobile-number");
                    if (nsMobileNum) nsMobileNum.value = response.data.data.mobile;

                    const debugWrapper = step2Form.querySelector(".debug-code-wrapper");
                    const debugVal = step2Form.querySelector(".debug-code-value");
                    if (response.data.data.debug_code) {
                        if (debugVal) debugVal.textContent = response.data.data.debug_code;
                        if (debugWrapper) debugWrapper.style.display = 'block';
                    } else {
                        if (debugWrapper) debugWrapper.style.display = 'none';
                    }
                }
            })
            .catch(err => {
                console.error(err);
                form.classList.remove('loading');
                if (mobileInput) mobileInput.removeAttribute("readonly");
            });
    });

    document.addEventListener("verify_code", function (e) {
        const form = e.target;
        if (form.classList.contains("loading")) {
            return;
        }
        const codeInput = form.querySelector("input#ns-mobile-verify");
        if (!codeInput || codeInput.value.length === 0) {
            return;
        }

        form.classList.add('loading');
        const resultEl = form.querySelector('.login-result');
        if (resultEl) {
            resultEl.textContent = '';
            resultEl.classList.add("hide");
        }

        const mobileInput = form.querySelector("input#ns-mobile-number");
        const nonceEl = form.querySelector("[name='ns-nonce']");

        codeInput.setAttribute("readonly", "true");

        const params = new URLSearchParams();
        params.append('action', 'negarshop_smart_login_myaccount_verify_mobile');
        params.append('mobile', mobileInput ? mobileInput.value : '');
        params.append('code', codeInput.value);
        params.append('_nonce', nonceEl ? nonceEl.value : '');

        fetch(NS_OBJ.ajax_url, {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: params
        })
            .then(res => res.json())
            .then(response => {
                form.classList.remove('loading');

                if (!response.success) {
                    if (resultEl) {
                        resultEl.textContent = response.data.message;
                        resultEl.classList.remove("hide");
                    }

                    setTimeout(() => {
                        if (resultEl) {
                            resultEl.textContent = '';
                            resultEl.classList.add("hide");
                        }
                    }, 5000);
                    codeInput.removeAttribute("readonly");
                } else {
                    form.remove();
                    window.location.reload();
                }
            })
            .catch(err => {
                console.error(err);
                form.classList.remove('loading');
                codeInput.removeAttribute("readonly");
            });
    });

})();
